import { render, staticRenderFns } from "./CortesList.vue?vue&type=template&id=c5fada70&scoped=true"
import script from "./CortesList.vue?vue&type=script&lang=js"
export * from "./CortesList.vue?vue&type=script&lang=js"
import style0 from "./CortesList.vue?vue&type=style&index=0&id=c5fada70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fada70",
  null
  
)

export default component.exports